import type { QuadroCompraCard } from '@/lib/solicitacoes-compra-store';

/**
 * 🔴 #377 (22/09/2026): a cancelada NÃO leva à cotação — nem "Cotar", nem "Ver cotação". Antes, a que já tinha cotação mantinha o "Ver
 * cotação", e a cotação deixava escolher fornecedor, receber e EFETIVAR a compra cancelada (o servidor agora recusa; a tela para de levar
 * até lá). Uma regra, usada pelo card e pelo diálogo do Quadro.
 */
export function podeCotarOCard(card: Pick<QuadroCompraCard, 'solicitacaoId' | 'cancelada'>): boolean {
  return !!card.solicitacaoId && !card.cancelada;
}
